import { useEffect, useState } from 'react';
import { Checkbox, Flex, Typography } from '@banhala/ui-kit';
import { isWeb, resolveWebURL, useNavigator } from 'shared/src/utils';
import { useOpenOutlink } from 'shared/src/utils/navigator/openOutlink';

type Props = {
  /** 필수 약관 3종 전체 동의 여부를 상위 폼에 전달 */
  onChange: (allAgreed: boolean) => void;
};

// 약관 본문 경로
const AGREEMENT_PATH = {
  termsOfUse: '/agreement/terms-of-use',
  privacyUse: '/agreement/privacy-use-agreement',
  userAge: '/agreement/user-age-agreement',
} as const;

/**
 * 가입 약관 동의 (이용약관/개인정보/만14세) + 전체동의. (webview RegisterDrawer/TermsForm 대응)
 */
export const TermsForm = ({ onChange }: Props) => {
  const openOutlink = useOpenOutlink();
  const { navigator } = useNavigator();
  const [terms, setTerms] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [age, setAge] = useState(false);

  const allAgreed = terms && privacy && age;

  useEffect(() => {
    onChange(allAgreed);
  }, [allAgreed, onChange]);

  const toggleAll = () => {
    const next = !allAgreed;
    setTerms(next);
    setPrivacy(next);
    setAge(next);
  };

  const openAgreement = async (path: string) => {
    if (isWeb) {
      openOutlink(await resolveWebURL(path));
      return;
    }
    navigator.moveToWebview(path, { titleBar: true });
  };

  return (
    <Flex gap={12}>
      <Checkbox value={allAgreed} label={'약관 전체 동의'} onPress={toggleAll} />
      <Flex horizontal alignItems={'center'} justifyContent={'space-between'}>
        <Checkbox
          value={terms}
          label={'[필수] 이용약관 동의'}
          onPress={() => setTerms(prev => !prev)}
        />
        <Flex onPress={() => openAgreement(AGREEMENT_PATH.termsOfUse)}>
          <Typography type={'body4'} color={'content_tertiary'}>
            {'보기'}
          </Typography>
        </Flex>
      </Flex>
      <Flex horizontal alignItems={'center'} justifyContent={'space-between'}>
        <Checkbox
          value={privacy}
          label={'[필수] 개인정보 수집·이용 동의'}
          onPress={() => setPrivacy(prev => !prev)}
        />
        <Flex onPress={() => openAgreement(AGREEMENT_PATH.privacyUse)}>
          <Typography type={'body4'} color={'content_tertiary'}>
            {'보기'}
          </Typography>
        </Flex>
      </Flex>
      <Flex horizontal alignItems={'center'} justifyContent={'space-between'}>
        <Checkbox
          value={age}
          label={'[필수] 만 14세 이상입니다'}
          onPress={() => setAge(prev => !prev)}
        />
        <Flex onPress={() => openAgreement(AGREEMENT_PATH.userAge)}>
          <Typography type={'body4'} color={'content_tertiary'}>
            {'보기'}
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  );
};
